function FactCheck({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      width="23"
      height="22"
      viewBox="0 0 23 22"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M4.2821 18.7917C3.81903 18.7917 3.42708 18.6313 3.10625 18.3105C2.78542 17.9896 2.625 17.5977 2.625 17.1346V4.86548C2.625 4.40241 2.78542 4.01046 3.10625 3.68962C3.42708 3.36879 3.81903 3.20837 4.2821 3.20837H18.3846C18.8476 3.20837 19.2396 3.36879 19.5604 3.68962C19.8813 4.01046 20.0417 4.40241 20.0417 4.86548V17.1346C20.0417 17.5977 19.8813 17.9896 19.5604 18.3105C19.2396 18.6313 18.8476 18.7917 18.3846 18.7917H4.2821ZM4.2821 17.4167H18.3846C18.4551 17.4167 18.5198 17.3873 18.5784 17.3285C18.6373 17.2698 18.6667 17.2052 18.6667 17.1346V4.86548C18.6667 4.79489 18.6373 4.73027 18.5784 4.6716C18.5198 4.61278 18.4551 4.58337 18.3846 4.58337H4.2821C4.21152 4.58337 4.1469 4.61278 4.08823 4.6716C4.02941 4.73027 4 4.79489 4 4.86548V17.1346C4 17.2052 4.02941 17.2698 4.08823 17.3285C4.1469 17.3873 4.21152 17.4167 4.2821 17.4167ZM5.14583 15.3542H9.27083V13.9792H5.14583V15.3542ZM13.6708 13.4239L17.8822 9.21254L16.9021 8.23239L13.6708 11.4866L12.3646 10.1803L11.4074 11.1605L13.6708 13.4239ZM5.14583 11.6875H9.27083V10.3125H5.14583V11.6875ZM5.14583 8.02087H9.27083V6.64587H5.14583V8.02087Z" />
    </svg>
  );
}

export default FactCheck;
